import React from 'react';
import Product from '../Product';

function Trousers () {
    return (
        <div>
            <div>
                <Product title="Trousers" start={5} end={11} />
            </div>
        </div>
    )
}

export default Trousers;